import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const includes = ['Plan completo de 8 semanas día por día', 'Instrucciones exactas para cada sesión', 'Guía de calentamiento y estiramiento', 'Consejos para NO abandonar en el proceso.', 'Cómo evitar lesiones y dolores', 'Plan de mantenimiento post-5K'];
  return <section ref={ref} className="py-20 px-4 bg-navy-light" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-117">
          {/* Ebook mockup */}
          <motion.div className="relative" initial={{
          opacity: 0,
          x: -50
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-118">
            <div className="rounded-2xl shadow-2xl shadow-accent/30 overflow-hidden" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/owiJuk76iB4R8hJMVXwv2m/5k_sin_rendirse_(19).png" alt="5K Sin Rendirse - Tu plan completo de 8 semanas" className="w-full h-auto rounded-2xl" data-id="element-120" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-121">
            <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-122">
              Tu plan completo,{' '}
              <span className="text-accent" data-id="element-123">listo para seguir sin pensar</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-124">
              Recibís acceso inmediato a todo lo que necesitás para pasar de
              sedentario a corredor en 8 semanas.
            </p>
            <div className="space-y-4" data-id="element-125">
              {includes.map((item, i) => <motion.div key={i} className="flex items-start gap-3" initial={{
              opacity: 0,
              x: 20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.3 + i * 0.1
            }} data-id="element-126">
                  <CheckCircle2 className="text-accent flex-shrink-0 mt-1" size={24} data-id="element-127" />
                  <p className="text-lg text-gray-200" data-id="element-128">{item}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}